import { render, staticRenderFns } from "./NoticiaSliderComponent.vue?vue&type=template&id=43c9d48d&scoped=true"
import script from "./NoticiaSliderComponent.vue?vue&type=script&lang=ts"
export * from "./NoticiaSliderComponent.vue?vue&type=script&lang=ts"
import style0 from "./NoticiaSliderComponent.vue?vue&type=style&index=0&id=43c9d48d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c9d48d",
  null
  
)

export default component.exports